module.exports = __webpack_public_path__ + "static/img/intro-thumb-1-dot.b0d5d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newImg/intro-thumb-1-dot.png
// module id = rGkM
// module chunks = 0